/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Item from '../../../../models/Item';
import DetailLineItems from './DetailLineItems';
import InfoBox from '../../../common/InfoBox';
import { AttachmentType } from '../../../../config/constants';
import OverviewItems from '../../../../config/overview';
import AttachmentUploader from '../../../common/AttachmentUploader';
import formPropsType from '../../../common/types/formPropsType';
import './Overview.css';
import AttachmentLineItem from './AttachmentLineItem';

class Overview extends Component {
  render() {
    const { item, formProps, startInEditMode } = this.props;

    const uploadCallback = (results) => {
      formProps.setFieldValue('attachments', [...item.attachments, ...results]);
      formProps.handleSubmit();
    };

    const onDeleteAttachment = (attachment) => {
      const atts = item.attachments.filter((att) => {
        return att.id !== attachment.id;
      });

      formProps.setFieldValue('attachments', atts);
      formProps.handleSubmit();
    };

    return (
      <div className="overviewGrid">
        <InfoBox title="Overview">
          <dl>
            <DetailLineItems
              item={item}
              properties={OverviewItems.overview[item.category]}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />
          </dl>
        </InfoBox>

        <InfoBox title="Specifications" className="specifications">
          <dl>
            <DetailLineItems
              item={item}
              properties={OverviewItems.specifications[item.category]}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />
          </dl>
        </InfoBox>

        <InfoBox title="Purchase Information">
          <dl>
            <DetailLineItems
              item={item}
              properties={OverviewItems.purchase_information[item.category]}
              formProps={formProps}
              startInEditMode={startInEditMode}
            />

            <dt>Attachments:</dt>
            {item.attachments
              .filter(a => a.type === AttachmentType.PURCHASE)
              .map(a => (
                <dd key={a.id}>
                  <AttachmentLineItem
                    attachment={a}
                    formProps={formProps}
                    onDeleteAttachment={onDeleteAttachment}
                  />
                </dd>
              ))}
            <dd>
              <AttachmentUploader
                attType={AttachmentType.PURCHASE}
                onSuccess={uploadCallback}
              />
            </dd>
          </dl>
        </InfoBox>
      </div>
    );
  }
}

Overview.propTypes = {
  item: PropTypes.instanceOf(Item).isRequired,
  formProps: formPropsType.isRequired,
  startInEditMode: PropTypes.bool,
};

Overview.defaultProps = {
  startInEditMode: false,
};

export default Overview;



// WEBPACK FOOTER //
// ./src/components/pages/collections/items/Overview.jsx